export const CHART_FONT_SIZE = "12";